import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobProfileComponent } from './job-profile.component';
import { TabsModule, TooltipModule } from 'ngx-bootstrap';
import { InfoIconModule } from 'src/app/shared/info-icon/info-icon.module';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { RequisitionSkillsModule } from 'src/app/shared/requisition-skills/requisition-skills.module';
import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';

@NgModule({
  declarations: [JobProfileComponent],
  imports: [
    CommonModule,
    TabsModule.forRoot(),
    TooltipModule,
    InfoIconModule,
    PipesModule,
    RequisitionSkillsModule,
    SkeletonLoaderModule
  ],
  exports: [JobProfileComponent],
  entryComponents: [JobProfileComponent]
})
export class JobProfileModule { }
